(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5198],{

/***/ 74350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./40.png": 78843,
	"./affiliates1.png": 50210,
	"./affiliates2.png": 43334,
	"./bolosign-hubspot.png": 40831,
	"./capterra.png": 20138,
	"./earn1.png": 278,
	"./earn2-copy.png": 28994,
	"./earn2.png": 46969,
	"./earn3.png": 32160,
	"./google-workspace.png": 21346,
	"./group.png": 43488,
	"./media-kit1.png": 96415,
	"./media-kit2.png": 91852,
	"./person.png": 25440,
	"./promote1.png": 90645,
	"./promote2.png": 78065,
	"./promote3.png": 99742,
	"./signup1.png": 97520,
	"./signup2.png": 16611,
	"./signup3.png": 30568,
	"./success.jpg": 37868,
	"./success.png": 17103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74350;

/***/ }),

/***/ 82805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/electric-signature-legality",
      function () {
        return __webpack_require__(97305);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/40.490b1dee.png","height":301,"width":711,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAPFBMVEWHh4ecnJwAAABiYmKUlJRXV1eBgYFiYmKIiIi0tLRCQkK5ubkpKSlhYWFmZmanp6eZmZmGhoZycnLKysqtsWnGAAAAE3RSTlPk4RZvT3jTi6LUluQ90mbNNf6jPavqIQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACNJREFUeJxjEOBm5eRg4eBh4BRmY2TgExRiYGbg4udlYmcHAAvTANcUcVurAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 50210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates1.c0070cc6.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX+5d704NX+7+v7+vjd5M7r5+TP2rz/5+KU2pOk2J3Oy8zi3+nGxcPq4dHf4tPZz+7T0dDOjqjRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nB3IQRKAIBAEsQYWZhZQ/P9rLc0xgGLw0ZUeApW086+0XYDa74gKauvM1YT6ns/uegEgZAE8oolrqQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 43334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates2.7641f663.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEXY9P7Y8vbm7db9yTrn+PnLzc/l57jr4Jry1m/3+PjExsbX3N3g3uji5sT30FzUzu5ACGK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3ISQ4AIQzEQKeTsMP8/7cj8MkqwIqMm3Z9Y9W9PGl+2qUISQH09eXqwMyRY/IDFB0A3NgNDvgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 40831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/bolosign-hubspot.2b496dd6.png","height":545,"width":687,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAVFBMVEVMaXHw7fP04NCfd//r4dfLsf3m4O+1i//k2+rTvunPv/Tz1r+7nPrpxcz06OHw9vzQwPjZxvzbzPr06tz36d/z6e/z9/r4rXTGof//48v/5tP///opxiHIAAAAGHRSTlMAk2MgGfl7/kILYCzj/t5bzfieSvT5oPgqFfrBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nCXBWwKAEBRAwUO4V5Leof3v00czYJ8zbCZie7u91ID53iy7HOjV1qV6hVScm5VfnBg8TwHlOZkZWAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 20138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/capterra.65e2d98f.png","height":163,"width":534,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAJFBMVEWnpqPHrGSfm5bbu2ukm4imnpO/tKaEg37pyHlcZl1DVVHcy8G5vcSGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNg52LgYGRiYmBg4+RmZmRlYQAAAq8ARknS1UkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/earn1.b3a35d50.png","height":629,"width":785,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAALVBMVEX//v7h4eDf0/38+fjy8fHp7vL+7unRz9XU0dzl3cmcnJ3n3pjNzcbn6OjV0uIXwQMtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nDXIyQ0AIAwEsVlCCHf/5SKQ8NOotrZrCNIDS8pc7p7NSkH6ZWP2gAMULQCxtcRiKQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 28994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/earn2-copy.c0b3d94e.png","height":690,"width":823,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAASFBMVEXU8f3O1tzs8uju56vp9fjm6MHQ1c////7V1dT2+Pnj7+Px8e3+yDfb7+rg3tzQ4OjZ9/rW69jT0cTw3pL5+Oz11nzZ2PDd38ad0wAGAAAACXBIWXMAAAzrAAAM6wHl1kTSAAAAOElEQVR4nAXBhwGAIBAAsQO+Uuy6/6gmuG8W4Y7LblYkSZa2g+RE51QqHX3vRqdKfmXI4FlxRUj+M4EBvUZHkTYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 46969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/earn2.0083948b.png","height":656,"width":799,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAARVBMVEX+/v7g7/jk6Nbq3pXW1trd3d7q49/r9Pbh5OT09/fe6fPm6uvl48Xw6OuZ3ZfR3bz56OnQ7PL/1lytra3Jy8q9v7++3K9Bom14AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVR4nBXKRxLAIAwAsQUMtump/39qJjoL2nNfBuxShgP0ubZqcNZ8a0+HMySGdEYlS2lVTP+mWcw/PdYBw+zHDusAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 32160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/earn3.84c5fbe5.png","height":681,"width":481,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAANlBMVEX9/f3T37Tr4f2txIHz9vLOzsz/+OzU0t/v7Pj18v24zZXLs/vj58HLy8jFxcTl2/f/9M//88qJJEbdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nC3BWQIAEAhAwUdR2d3/sn7MoGWVCW5m5ny+c3gAqhXuEEmVM1pLQPSeeR3SARMvtTptAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 21346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/google-workspace.0f38bc85.png","height":146,"width":475,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAJ1BMVEWhn5qNgm+6so//taGY1sWnk2XMyrGysa/PnSK6wu6TkIzmvlr22piAcIgzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNg5mTjZmJgYGfgYWHiYGVk5AIAAvwAUhVDka4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 43488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/group.56b460ef.png","height":680,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAaVBMVEVMaXHXz/edzabHtP3UnudxeX3RwfSp5qPsmP+20tTe3N+eo6bu///Vmuq7yuW4/LXK/8zB0Ozk//9IUlSnhPu3nP/GzdOrsbqrlN3Qz8e/qfyr07G5oP/n3vTey8TNu8J+pYm4npSHcXcvD0r1AAAAG3RSTlMA6L9wKviaUi6O/fwPPcledNAm8oyW+vp6/lmZEK6SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOklEQVR4nAXBhQHAIADAsOIyYczd/j+SBJQQ58get3hN2G+Zb8v6m+pRyHcwh8R1uU0O+hBq0I33mgJP+gKLNQryPgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 96415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/media-kit1.7013d516.png","height":696,"width":697,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEWehnbXycWCVkQtIRxiTD/Fp49UPy5OOi1uSzVGMymNeGmHdnBvU0GckpCXf2xqXFammZKCZFGnjHdWQziAb2oYEhO1gWN3WkuLf32SeGPn29dOPjXew63Vuq3r7/fX1dbDk0XdvaTbs4impQVYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVR4nAXBhQGAMBAEsKt+hTpQ3PYfkgQ2yYGTNdi9A++ThcwdbjYCLeS6GhYg7yuWyEY8SOXc4PG9qqpDLSDSWlMTP3FoA0tv39OLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 91852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/media-kit2.874f1646.png","height":690,"width":698,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEX////96OL4/P361cvw9/bk9uTW2NX75fve8vr+9/3/8ezS7PfZ29nk4fjt3fj62tH/39btzS3nAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nCWISRLAIBCE0MzSE83y/9emolygoEfEjGlg7u4GtOPsY0A97ZVk+0j8ZNZy3Veu2OcDL4YBN1T3D3cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 25440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/person.b7fcb719.png","height":603,"width":604,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAh1BMVEVMaXGg0Z/H4sDRpYxPOjCSv5FIQ0FtjGza/99nZ2S7/bvg/9uifGyXuJXD68BVY3NrdYOCn35USknSm3tqTkSavpa39bZ6knSfzptjgZ2IkZyz47OAg5HW/djA8L63/7ef75dfZG1OPjpZV1AyNDQfJTE8TmaSorK01q49XH3GtqXh3dny9+zZ0AFfAAAAI3RSTlMAm9z+/Jn83hz+4B3+3dz+/OH9/v3avtTY/fyf9tubICD++v7vA58AAAAJcEhZcwAACxMAAAsTAQCanBgAAABLSURBVHicBcGJEoAQAAXAR0gI3fcxo7v+//vaBSTJYi4BXSV5GVINEgQr2MaRBrGZZG9gX3+f3RFj/kbXe9dinR4TRZcCloFSq+oflKoEjmvo2y4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 90645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/promote1.88f87825.png","height":655,"width":486,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAWlBMVEXk3+3OvPn87eD13fOuj/bt6vK5nvf9/v/3/f7r+P7H9c+xxtL4vsz/9Obf6vb08vrw4dv7r56mtsKI06/m7+fx/+vb9NTsqeCYzNDS2OzRlMt6tsbp/Nyt3817gNlMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOElEQVR4nAXBBQLAIAwAsUPbAnO3/39zCZ0v57fhx/IsL+E+1r0RpnZVQwarsyG9qgoJIOFiztH9SkECGiFAQ14AAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 78065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/promote2.9377b187.png","height":676,"width":685,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEX////t+Pz/8/H2+/b94tzp++r7+v/U19Pa8fr64vr/7P3n3vj62dDG4u/x8fD60cfn+PG/va+VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB2Ixw3AQAyAcI2vZv9to5gPCO7TGFhEhAH+qpwC3e4lJeBbswogx8jfzLVmB30+Lr8BMUIggIIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 99742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/promote3.f16598d3.png","height":548,"width":789,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAS1BMVEX9/v/W1NTQ0NXWxeHl5ujr6evd3OO7vLzFxcjX2Njs+unl8P7x4OT14sjk4PzT7P+81ujaz7v/8u7mlpz67fqtos/qu7+2pOHJtOgGv2S6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nAXBhwHAIAzAMAeyoHvS/y+tBBYRClzNRY594z2r9cVB7/ExreBPqbMpSGTJbPwphwGACx635AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 97520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/signup1.9c16e291.png","height":694,"width":490,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAIVBMVEX///759/339fL07f338vzw5eHTwfvp+O3Aqfj/+vbHtfYHhkkSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nBXJQRIAIAgDsW0BUf7/YIdcg12VIsMG3mMppAjOnbkH3L1padNO8QEQjgCM6X+K4wAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 16611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/signup2.3ea6b47b.png","height":695,"width":693,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEXN6PNkcnfBxMSZo6bn+v70+fzb9v/R19va4OL////29PG1zNTz///S7/fGyNrd1vaeeO7IyMiEhYW64erj7e7Y4v54i5Hv6fPt6PPczfGqusKps7Oymt+MkaKut96Ehau/oPrqY4TJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBBQKAMAwEsJu2neMO+/8rSSCW9UBOYMFBRpPgwdNslIUHLU4rj5TLsZECBKXuvEb01u5AkVDf77nO7H5RsgLgk/IheAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 30568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/signup3.0ce93291.png","height":276,"width":555,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAM1BMVEW9v9Xe8viqke7m8/fm6+n//P74+vrj5d/7+/js+vvj2/q3ttXd0/q4nvft6fD17v+olN3hZIFPAAAADHRSTlPpz/6x6Pqx29jn/eS/1qqEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nAXBAQIAEAgAsUOpKPz/tTaGipn5JDQz13Xi9Kp6ThNgMz8R7ADxK+814gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 37868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/success.2a367b2a.jpg","height":68,"width":301,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAEAAgMAAAAAAAAAAAAAAAAAAREDIUH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AruHU1ywBMx//2Q==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 17103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/success.b0209025.png","height":68,"width":301,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEX3+vj+/v7t9vHf7+aosZp8AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAGUlEQVR4nAXBAQEAAACCIM3/nwMqVNgG6AEA8wAVFlTZyQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 8058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero1.306345df.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEX08/T////v7uz9/P3e5OD4+fno2+nu7vLp6enf09/V0Nbt3/2/r6jH4sY/1g1MAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAN0lEQVR4nCXGxw3AQAwEsdEqO/TfrnEwXyQj+jYzfLf+VG2RDk+ERk5WN+BwxSv1iWJGdqIk7QMpYgEWGrmJSgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero3.1b65818e.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXv7ezh2fvn4fv25fL18v3m4+Ln7O78+Pz18/T////47ufp7vvFpv/i0f/V1dPQtP/P0M/w6P/azvvtlTxZAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAPUlEQVR4nB3GQRKAIAwDwBTapgEU9f+PdXRPC7WGBAXZE9dZgu619uGC3KzNLzOTlYLGCBQE9R78QwdZegFDQAHITC0J7gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 61695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/only_solution2.dc5d6071.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEX////L9ePm5uv82M72/P/p+OXZ2drT1NTu+f/t6+35+P/2+fTc9PP/4tv47/nm+/K46fr08OHi1v7PvPtQ9mxIAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAO0lEQVR4nAXBBwLAIAgAsRNBhqPr/39tAsOHewLp7mNCvbW3LqW+03vcASmZIsBjZjaBvlprF3A0IpQfPloBn30PHkEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97005);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const CustomersMarquee = (param)=>{
    let { customersData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                children: customersData.map((card, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-surface text-black rounded-2xl px-11 py-16 mx-2 flex flex-col justify-between h-[520px] w-[390px] border border-surface-dark",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "bg-surface-dark rounded-md font-semibold px-4 py-2 text-gray-700 uppercase ",
                                    children: card.tag
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "inline-flex justify-center items-center p-3 bg-white rounded-xl border border-surface-dark",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/testimonials/comapnies/").concat(card.logo),
                                        alt: "Company Logo",
                                        className: "h-auto",
                                        width: 100,
                                        height: 100
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[18px] leading-[26px] text-black font-medium mb-6",
                                children: card.quote
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-semibold text-xl",
                                        children: card.author
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-base text-gray-500",
                                        children: card.authorTitle
                                    })
                                ]
                            })
                        ]
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomersMarquee);


/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 7026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




const CompanyOverview = (param)=>{
    let { heading , companyData , feedbackLinks  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full max-w-screen-mxl mx-auto",
        children: [
            heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-3xl sm:text-4xl font-bold mb-14 w-fit border-none mx-auto",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8",
                children: companyData.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-center gap-4 text-left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center items-center text-4xl text-white bg-violet-500 w-[80px] h-[80px] rounded-full",
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1 flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-5xl sm:text-6xl font-bold text-black",
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-md text-gray-900",
                                        children: item.label
                                    })
                                ]
                            })
                        ]
                    }, item.id))
            }),
            feedbackLinks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center flex-wrap gap-12 mt-14 removeBg",
                children: feedbackLinks.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: __webpack_require__(74350)("./".concat(item.image)),
                            alt: "",
                            width: 200,
                            height: 50
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompanyOverview);


/***/ }),

/***/ 18034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59183);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);






const Subscribe = (param)=>{
    let { heading ="Simple and Budget-Friendly Signing for Your Business" , paragraph ="One fixed price for unlimited signatures, templates, forms, and contracts—no extra charges for adding users and more signatures."  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-20 lg:py-40 mx-auto px-4 md:px-8 xxl:px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-mxl mx-auto flex flex-col lg:flex-row gap-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            heading2: heading,
                            paragraph: paragraph
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col sm:flex-row gap-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                buttonPrimaryText: "Get Started",
                                buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                    from: "WEBSITE_BOTTOM_BUTTON"
                                }))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full h-[500px] lg:h-auto lg:flex-1 relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(8058),
                            width: 10,
                            height: 10,
                            className: "moveRightAndCenterObject rounded-lg w-auto h-[50%] xs:h-[50%] sm:h-[70%] xl:h-[80%] imageBorders absolute left-[10%] top-1/2 z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(61695),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateLeftObject rounded-lg w-auto h-[30%] xs:h-[40%] sm:h-[50%] lg:h-[40%] xl:h-[65%] imageBorders absolute right-[5%] sm:right-[15%] md:right-[20%] xxl:right-[15%] top-0 lg:top-[-10%] z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(79251),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateRightObject rounded-lg w-auto h-[40%] xs:h-[50%] sm:h-[60%] lg:h-[50%] xl:h-[70%] imageBorders absolute right-[10%] sm:right-[30%] xxl:right-[20%] bottom-0 xl:bottom-[-20%] z-10",
                            alt: "hero"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Subscribe);


/***/ }),

/***/ 95291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ industryLeadersCard; }
/* harmony export */ });
// export const industryLeadersCard = [
//   {
//     tag: "1. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "Simple, straight to the point, with a lot of new features coming up. Great!",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "2. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     subTitle: "",
//     subDesc: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "3. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "4. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "5. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "6. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "7. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "8. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
// ];
const industryLeadersCard = [
    {
        tag: "marketplace",
        logo: "greenleaf.png",
        quote: "Simple, straight to the point, with a lot of new features coming up. Great!",
        author: "Jonathan S.",
        authorTitle: "Marketing Manager"
    },
    {
        tag: "fintech",
        logo: "elemenopillows.png",
        quote: "BoloForms transformed document signing with a user-friendly interface, secure e-signatures, and seamless customization, streamlining our procedures.",
        author: "Juan Diego P.",
        authorTitle: "Operations Executive"
    },
    {
        tag: "marketplace",
        logo: "techsolutions.png",
        quote: "It's cheap and it just works! I had to do mass signatures of our team members and Boloforms made it easy for us to get signatures from our team faster.",
        author: "Sam K.",
        authorTitle: "Sales Lead"
    },
    {
        tag: "fintech",
        logo: "freshstart.png",
        quote: "Finally a simple to use yet full featured PDF signature app!",
        author: "Lisa Brown",
        authorTitle: "Owner"
    },
    {
        tag: "delivery",
        logo: "rappi.png",
        quote: "BoloForms made our document workflows seamless. The intuitive interface and reliable e-signatures significantly improved our team’s efficiency.",
        author: "Groham ",
        authorTitle: "Head of Product"
    }
];


/***/ }),

/***/ 97305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56130);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2208);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59183);
/* harmony import */ var _components_CompanyOverview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7026);
/* harmony import */ var _components_Cards_ClientsTestimonial__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59471);
/* harmony import */ var _components_Legality__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95499);
/* harmony import */ var _components_Subscribe__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18034);
/* harmony import */ var components_CLM_Customers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5297);
/* harmony import */ var _constants_customersData__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95291);


















const ElectricSignatureLegality = (param)=>{
    let { countries  } = param;
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
    const [selectedCountry, setSelectedCountry] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Select Country");
    const handleCountryChange = (event)=>{
        setSelectedCountry(event.target.value);
        router.push("/signature/electric-signature-legality/".concat(event.target.value));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-8 md:mt-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Are eSignatures legal? | Electronic Signature Laws by Country"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "An eSignature provides the same legal standing as a handwritten signature as long as it adheres to the requirements of the specific regulation it was created under. Join millions of professionals and business owners that have replaced manual paper signing for the speed and security of eSignatures."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Are eSignatures legal, Electronic Signature Laws by Country, eSignature Laws, eSignature Laws by Country, eSignature Laws by Country 2022, eSignature Laws by Country 2023"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/electric-signature-legality/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Are eSignatures legal? | Electronic Signature Laws by Country"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/electric-signature-legality/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Are eSignatures legal? | Electronic Signature Laws by Country"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/electric-signature-legality/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-24 md:gap-40",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 md:px-8 ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Legality__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            dropDown: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl mx-auto flex flex-col gap-8 w-full px-4 lg:px-8 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "max-w-[900px] mx-auto text-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    heading2: "List of countries where eSignatures are legal",
                                    paragraph: "An eSignature provides the same legal standing as a handwritten signature as long as it adheres to the requirements of the specific regulation it was created under."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10",
                                children: countries.map((country, index)=>{
                                    var _country_esignLaws;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-2 border border-surface-dark rounded-xl transition-all duration-500 ease-in-out bg-surface-light overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full relative bg-white",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/legality/legal-country2.svg"),
                                                        alt: "",
                                                        width: 10,
                                                        height: 10,
                                                        className: "w-full ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_16___default().legalImages), " grayscale-[1]")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex items-center gap-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: "https://flagcdn.com/h20/".concat(country.code, ".png"),
                                                                alt: "",
                                                                width: "10",
                                                                height: "10",
                                                                className: "w-12 h-8 border border-gray-400"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-sm uppercase font-bold text-gray-700",
                                                                children: country.country
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "p-6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-black text-2xl text-center mb-3",
                                                        children: country.country
                                                    }),
                                                    country === null || country === void 0 ? void 0 : (_country_esignLaws = country.esignLaws) === null || _country_esignLaws === void 0 ? void 0 : _country_esignLaws.map((law, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-gray-900 text-xl text-left",
                                                            children: law
                                                        }, index))
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "bg-surface-dark py-20 mt-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[1280px] max-w-full mx-auto pb-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                    className: "text-4xl md:text-5xl md:text-left text-center font-semibold text-black",
                                    children: [
                                        "Industry leaders fly with BoloSign. ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " It's your turn to rise with AI."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_Customers__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                customersData: _constants_customersData__WEBPACK_IMPORTED_MODULE_15__/* .industryLeadersCard */ .Z
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ElectricSignatureLegality);


/***/ }),

/***/ 10411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signatureFont":"signature_signatureFont__RxQpu","signatureShadow":"signature_signatureShadow__hfutn","headingAnimation":"signature_headingAnimation___OGQQ","changeImageAnimation":"signature_changeImageAnimation__xeM9_","moveLineAnimation":"signature_moveLineAnimation__uc0qS","changeHeightAnimation":"signature_changeHeightAnimation__AjMNd","rotateIconsAnimation":"signature_rotateIconsAnimation__pFB1R","moveStepsLineAnimation":"signature_moveStepsLineAnimation__MUlje","moveTextUpAnimation":"signature_moveTextUpAnimation__Y6QVi","scrollImageAnimation":"signature_scrollImageAnimation___7bVj","scrollImageAnimationMobile":"signature_scrollImageAnimationMobile__pGKm5","stepsImage":"signature_stepsImage__zJWMg","countryImage":"signature_countryImage__wMRyn","imagePosition":"signature_imagePosition__iJEJi","legalImages":"signature_legalImages__3yVVS","loader":"signature_loader__Zqlyl","topBg":"signature_topBg__j0SDC"};

/***/ }),

/***/ 97005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9642,4599,9471,5499,9774,2888,179], function() { return __webpack_exec__(82805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);